import { isPostalCode } from 'validator'
import {
    getLocalItem,
    getLocalJSON,
    isLocalStorageAvailable,
    removeLocalItem,
    setLocalItem,
    setLocalJSON,
} from '../browser-storage'

const GUEST_ZIP_KEY = 'hazadapt_guest_zip'
const GUEST_TUTORIALS_KEY = 'hazadapt_guest_tutorials'

/**
 * Save the guest's ZIP code to localStorage
 * @param zip The ZIP code to save
 * @returns true if saved successfully, false otherwise
 */
export const saveGuestZip = (zip: string): boolean => {
    if (!isLocalStorageAvailable()) {
        console.error('localStorage is not available')
        return false
    }

    try {
        if (!isPostalCode(zip, 'any')) {
            console.error('Invalid ZIP or postal code format')
            return false
        }

        setLocalItem(GUEST_ZIP_KEY, zip)
        return true
    } catch (error) {
        console.error('Failed to save guest ZIP code:', error)
        return false
    }
}

/**
 * Get the guest's ZIP code from localStorage
 * @returns The guest's ZIP code, or null if none exists
 */
export const getGuestZip = (): string | null => {
    if (!isLocalStorageAvailable()) {
        return null
    }

    try {
        const zip = getLocalItem(GUEST_ZIP_KEY)

        if (zip && !isPostalCode(zip, 'any')) {
            console.warn('Stored ZIP or postal code is invalid, clearing...')
            removeLocalItem(GUEST_ZIP_KEY)
            return null
        }

        return zip
    } catch (error) {
        console.error('Failed to get guest ZIP code:', error)
        return null
    }
}

/**
 * Get the list of tutorials the guest has seen from localStorage
 * @returns Array of tutorial names
 */
export const getGuestTutorialsShown = (): string[] => {
    const data = getLocalJSON<string[]>(GUEST_TUTORIALS_KEY, [])
    if (!Array.isArray(data)) return []
    return data
}

/**
 * Mark a tutorial as shown for guest users, saves to localStorage
 * @param tutorialName The name of the tutorial to mark as shown
 */
export const markGuestTutorialShown = (tutorialName: string): void => {
    try {
        const shown = getGuestTutorialsShown()
        if (!shown.includes(tutorialName)) {
            shown.push(tutorialName)
            setLocalJSON(GUEST_TUTORIALS_KEY, shown)
        }
    } catch (error) {
        console.error('Failed to save guest tutorial:', error)
    }
}
